import React from "react";
import PropTypes from "kf-proptypes/widgets";

DeferComponent.propTypes = {
  delay: PropTypes.number,
  loader: PropTypes.node,
  children: PropTypes.node.isRequired
};

export function DeferComponent({ delay = 2000, loader = null, children }) {
  let [shouldRender, setShouldRender] = React.useState(false);

  React.useEffect(
    function calculateDefer() {
      let frameOneId, frameTwoId;
      let timerId = setTimeout(() => {
        frameOneId = requestAnimationFrame(() => {
          // eslint-disable-next-line max-nested-callbacks
          frameTwoId = requestAnimationFrame(() => {
            setShouldRender(true);
          });
        });
      }, delay);

      return () => {
        window.clearTimeout(timerId);
        frameOneId && window.cancelAnimationFrame(frameOneId);
        frameTwoId && window.cancelAnimationFrame(frameTwoId);
      };
    },
    [delay]
  );

  return shouldRender ? children : loader;
}
